export default class ToggleTargets {
  constructor() {
    this.init();
  }

  init() {
    this.updateElements();
    document.addEventListener('DOMContentLoaded', () => this.updateElements());
    document.addEventListener('change', (e) => this.handleChange(e));
  }

  updateElements() {
    document.querySelectorAll('[data-radio-toggle]').forEach((radio) => {
      const targetName = radio.getAttribute('data-radio-toggle');
      const isChecked = radio.checked;
      const targets = document.querySelectorAll(`[data-radio-toggle-target="${targetName}"]`);

      targets.forEach((elem) => {
        if (!elem.dataset.originalDisplay) {
          elem.dataset.originalDisplay = getComputedStyle(elem).display;
        }

        elem.hidden = !isChecked;

        // Disable/Enable form fields inside hidden elements
        const formElements = elem.querySelectorAll('input, select, textarea, button');
        formElements.forEach((field) => {
          field.disabled = !isChecked;
        });
      });
    });
  }

  handleChange(event) {
    if (event.target.closest('[data-radio-toggle]')) {
      this.updateElements();
    }
  }
}
